
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class TopSeenLectureGrid extends Serenity.EntityGrid<TopSeenLectureRow, any> {
        protected getColumnsKey() { return 'Workspace.TopSeenLecture'; }
        protected getDialogType() { return TopSeenLectureDialog; }
        protected getLocalTextPrefix() { return TopSeenLectureRow.localTextPrefix; }
        protected getService() { return TopSeenLectureService.baseUrl; }

        private nextId = 1;
        private ProductId: string;

        public rowSelection: Serenity.GridRowSelectionMixin;
        constructor(container: JQuery, ProductId: string) {
            super(container);
            debugger;
            this.ProductId = ProductId;
        }

      
        protected createQuickSearchInput() { }


        protected onViewProcessData(response: Serenity.ListResponse<TopSeenLectureRow>) {
            response = super.onViewProcessData(response);

            // there is no __id property in CustomerGrossSalesRow but 
            // this is javascript and we can set any property of an object
            for (var x of response.Entities) {
                (x as any).__id = this.nextId++;
            }
            return response;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            
            var productFilter = this.addQuickFilter({
                type: Serenity.LookupEditor,
                field: TopSeenLectureRow.Fields.ProductId,
                title: "Product",
                options: {
                    lookupKey: "Workspace.Products"
                },
                handler: (args) => {
                    var typeId = args.widget.value;
                    (args.request as TopSeenLectureListRequest).ProductId = Q.toId(typeId);
                   
                }
            });
            productFilter.init(t => {
                productFilter.value = this.ProductId;
            });
            Serenity.EditorUtils.setReadonly(productFilter.element, true);

            return filters;
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/TopSeenLecture/ListExcel',
                separator: true
            }));
            return buttons;
        }
       
    }
}